// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

// Import Material UI
import { Checkbox, IconButton, makeStyles } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

// Import Recoil
import { changedFields, initialActions, saveAvailable } from '../../../recoil-store/recoil-state';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

// Import Pages
import ParamsModal from '../ParamsModal/ParamsModal';
import EditParamsModal from '../ParamsModal/EditParamsModal';

// Import Services
import VariableService from '../../../services/VariableService/VariableService';
import { addDifference, checkTheDifference, removeDifference } from '../../../helpers/helper';

// Import Icons
import selectDeleteIcon from '../../../assets/icons/configurationIcons/trash-box.svg'
import addParamIcon from '../../../assets/icons/configurationIcons/add-param-icon.svg'
import EditIcon from '../../../assets/icons/headerIcons/edit-icon.svg';

// Import CSS
import './Table.css';

const useStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        // backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#f5f8fa',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#f5f8fa',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            backgroundColor: '#4F6E90',
            width: 8,
            height: 8,
            backgroundImage:
                "",
            content: '""',
        },
        // 'input:hover ~ &': {
        //     backgroundColor: '#4F6E90',
        // },
    },
});

export default function Table({ action, options, automVersionId, inputName, isRequired, setOpenVariable, isActiveDirectory = false, formData, automId, headerWithVariable }) {
    const [open, setOpen] = useState(false)
    const [editOpen, setEditOpen] = useState(false);
    const [indexId, setIndexId] = useState(0);
    const [variable, setVariable] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const { t } = useTranslation();
    const [isControl, setIsControl] = useState([]);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const classes = useStyles();

    useEffect(() => {
        let y = Object.keys(action.fields)
        if (y.indexOf(inputName) === -1) {
            if (inputName !== undefined) {
                action.fields[inputName] = {};
                let x = Object.keys(action.fields[inputName])
                if (x.indexOf(inputName) === -1) {
                    action.fields[inputName] = { type: "TABLE", value: [], isRequired };
                }
            }
        }

    }, [action])

    useEffect(() => {
        if (refresh) {
            VariableService.getVariable(automVersionId)
                .then((response) => {
                    if (response.data) {
                        if (Array.isArray(response.data)) {
                            setVariable(response.data)
                        } else {
                            setVariable([response.data])
                        }
                    } else {
                        setVariable([])
                    }
                })
                .catch((error) => {
                    //err
                });
            setRefresh(false);
        }
    }, [refresh]);

    useEffect(() => {
        let y = Object.keys(action.fields)
        setIsControl(y);
    }, [inputName])
    const handleClick = (index) => {
        setEditOpen(true);
        setIndexId(index);
    }

    const handleSetActive = (e, index) => {
        const field = initialActionsData[action.id]?.fields[inputName];
        const oldValue = !field ? undefined : field.value[index]?.isActive;
        const cfTemp = JSON.parse(JSON.stringify(changedFieldsState));
        if (!oldValue) {
            addDifference(cfTemp, action, inputName, setChangeFields, setSaveAvailable)
        } else {
            const arr1 = action.fields[inputName].value;
            let key = 'isActive'
            if (checkTheDifference(arr1, oldValue, [key])) {
                addDifference(cfTemp, action, inputName, setChangeFields, setSaveAvailable)
            } else {
                removeDifference(cfTemp, action, inputName, setChangeFields, setSaveAvailable)
            }
        }
        action.fields[inputName].value[index].isActive = e.target.checked;
        setRefresh((pre) => !pre)
    }

    const handleDelete = (index) => {
        action.fields[inputName].value.splice(index, 1);

        // the difference between the old value and the new value is checked
        const field = initialActionsData[action.id]?.fields[inputName];
        const oldValue = !field ? undefined : field.value;
        const cfTemp = JSON.parse(JSON.stringify(changedFieldsState));
        if (!oldValue) {
            addDifference(cfTemp, action, inputName, setChangeFields, setSaveAvailable)
        } else {
            const arr1 = action.fields[inputName].value;
            let key = isActiveDirectory ? 'value' : 'name'
            if (checkTheDifference(arr1, oldValue, [key])) {
                addDifference(cfTemp, action, inputName, setChangeFields, setSaveAvailable)
            } else {
                removeDifference(cfTemp, action, inputName, setChangeFields, setSaveAvailable)
            }
        }
        setRefresh((pre) => !pre)
    };

    const handleExpand = (e) => { e.target.classList.toggle('content-overflow'); }
    return (
        <div style={{ width: '100%' }}>
            <div>
                <span>{t(options?.title)}</span>
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.ADD-UNIQUE-DATA-PARAM')}</em></small>


            </div>
            <div>
                <div className='query-table-grid' style={{
                    gridTemplateColumns: `${options?.headers.length > 1 ? "1fr 1.4fr" : "1fr"}`
                }}>
                    {options?.headers?.map((item, itemI) =>
                        <div className={`query-grid-item ${itemI === 0 && options?.headers.length > 1 ? "item-seperator" : ""}`} key={itemI}>{t(item)}</div>
                    )}
                    <IconButton style={{ padding: 0, position: "absolute", right: "4px" }} onClick={() => setOpen(!open)}>
                        <AddCircleOutlineIcon style={{ color: "#FCFCFC", fontSize: "1.2rem" }} />
                    </IconButton>
                </div>

                {(action.fields !== undefined && isControl.indexOf(inputName) !== -1 && Array.isArray(action.fields[inputName]?.value) && action.fields[inputName]?.value.length) ? action.fields[inputName].value.map((item, index) => {
                    if (!isActiveDirectory) {
                        return item.value || item.name ? <div className='param-value-container' key={index}
                            style={{ gridTemplateColumns: "1fr 1.4fr", opacity: `${item.isActive ? "1" : "0.5"}` }}>
                            {/* <div style={{ width: '6rem' }}>{item.isActive ? 'Active' : 'Passive'}</div> */}
                            <Checkbox
                                style={{ position: "absolute" }}
                                className={classes.root}
                                disableRipple
                                color="default"
                                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                                icon={<span className={classes.icon} />}
                                inputProps={{ 'aria-label': 'decorative checkbox' }}
                                checked={item.isActive}
                                onChange={(e) => handleSetActive(e, index)}
                            />
                            <div className='query-grid-item item-seperator'><span className="content-overflow" >{item.name}</span></div>
                            <div className='query-grid-item'><span className="content-overflow" >{item.value}</span></div>
                            {/* <div style={{ cursor: "pointer", width: "2rem", position: "absolute", right: "20px" }} onClick={() => handleClick(index)}><CreateIcon
                                style={{ width: "20px", height: "20px", marginTop: "0.2rem" }}
                            /></div> */}
                            <div className='value-action-container'>
                                <img src={EditIcon} onClick={() => handleClick(index)} />
                                <img src={selectDeleteIcon} onClick={() => handleDelete(index)} />
                            </div>
                        </div> : ""
                    }
                    else {
                        return item.value ? <div className='param-value-container' key={index}>
                            <div className='query-grid-item m-w-n' style={{ width: "100%" }}> <span className="content-overflow" >{item.value}</span></div>
                            {/* <div style={{ cursor: "pointer", maxWidth: "2rem" }} onClick={() => handleClick(index)}><CreateIcon
                                style={{ width: "20px", height: "20px", marginTop: "0.2rem" }}
                            /></div> */}
                            <div className='value-action-container'>
                                <img src={EditIcon} onClick={() => handleClick(index)} />
                                <img src={selectDeleteIcon} onClick={() => handleDelete(index)} />
                            </div>
                        </div> : ""
                    }
                }) : <div className='empty-param-table-container' onClick={() => setOpen(!open)}>
                    <img className='empty-param-table-add-icon' src={addParamIcon} />
                    <span className='empty-param-table-description'>{t('CONTENT.CONFIGURATION-FORM.ADD-ATTRIBUTE')}</span>
                </div>}
            </div>
            {open && (
                <ParamsModal
                    action={action} title={t(options?.title)}
                    variable={variable}
                    setOpen={setOpen}
                    setRefresh={setRefresh}
                    setOpenVariable={setOpenVariable}
                    inputName={inputName}
                    isActiveDirectory={isActiveDirectory}
                    formData={formData}
                    automId={automId}
                    headerWithVariable={headerWithVariable}
                />
            )}
            {editOpen && (
                <EditParamsModal
                    action={action} title={t(options?.title)}
                    variable={variable}
                    setOpen={setEditOpen}
                    indexId={indexId}
                    setRefresh={setRefresh}
                    setOpenVariable={setOpenVariable}
                    inputName={inputName}
                    isActiveDirectory={isActiveDirectory}
                    formData={formData}
                    automId={automId}
                    headerWithVariable={headerWithVariable}
                />
            )}
        </div>
    );
}
